export async function decodeVin(vin) {
    try {
      const response = await fetch(`https://vpic.nhtsa.dot.gov/api/vehicles/decodevin/${vin}?format=json`);
      const data = await response.json();
      return data.Results;
    } catch (error) {
      console.error('Error decoding VIN:', error);
      return [];
    }
  }
  
export function extractVehicleInfo(results) {
    const get = (name) =>
      results.find((r) => r.Variable === name)?.Value || '';
  
    return {
      make: get('Make'),
      model: get('Model'),
      model_year: get('Model Year'),
    };
  }
  